module.exports = "<li><a class=\"q-pad-horz-sm action-link {%- cls %} {% if (disabled) { %} disabled {% } %}\" href=# data-id=\"{%- id %}\" data-url=\"{%- url %}\"><i class=\"fa fa-{%- icon %} q-icon-marg-right\"></i>{%- title %}</a></li>";


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetEngine/html/globalHtml/actionLinkTemplate.html
// module id = 1130
// module chunks = 1